import { memo } from 'react';

import { IconType } from '../modules/data';
import { DamageType } from '../modules/generated/api';
import { damageTypes, getLabel } from '../modules/labels';

import HighlightIcon from './HighlightIcon';

type DamageTypeHighlightsProps = {
  damageType?: DamageType[];
};

const DamageTypeHighlights = ({ damageType = [] }: DamageTypeHighlightsProps) => (
  <>
    {damageType.map((d) => (
      <HighlightIcon key={d} type={IconType.DAMAGE_TYPE} label={getLabel(damageTypes, d)} value={d} />
    ))}
  </>
);

export default memo(DamageTypeHighlights);
